import { put, fork, takeLatest, call, select } from "redux-saga/effects";

import {
  constants as blogPostConstants,
  actions as blogPostAction,
} from "../actions/blog-post-action";

import { actions as homeActions } from "../actions/home-actions";
import { logout } from "../actions/auth-actions";

import {
  createBlogPost,
  getBlogPostByChannelId,
  getBlogPostByUser,
  searchBlogPost,
  searchBlogPostForLinkBuilder,
  updateBlogPost,
  deleteBlogPost,
  addBlogPostLike,
  removeBlogPostLike,
  getImagesCargEndPoint,
  saveBlogPost,
} from "../../api";

export function* createBlogPostSaga({ payload }) {
  yield put(homeActions.setLoading(true));

  try {
    const response = yield call(createBlogPost, { ...payload });

    if (response.status === 200 && payload.callback) {
      payload.callback();
    }
    yield put(homeActions.setLoading(false));
  } catch (error) {
    if (error && error.response && error.response.status === 401) {
      yield put(logout());
    } else if (payload.callback) {
      if (error.message === "Network Error") {
        return payload.callback(
          "Error internet connection, Please check your intenert connection and try again."
        );
      } else {
        const { msg } = error?.response?.data || {};
        payload.callback(msg || "Something went wrong, please try again.");
      }
    }
  } finally {
    yield put(homeActions.setLoading(false));
  }
}

export function* saveBlogPostSaga({ payload }) {
  // yield put(homeActions.setLoading(true));

  try {
    const response = yield call(saveBlogPost, { ...payload });

    if (response.status === 200) {
      if(payload.callback){
        payload.callback(response.data ? true : false);
      }

      const selectAllState = (state) => state;
      const allState = yield select(selectAllState);

      const blogsPosts = allState.blogPost.get("blogsPosts");
      const count = allState.blogPost.get("count");
      const countTaxonomys = allState.blogPost.get("countTaxonomys");

      const blogsPostsUpdated = blogsPosts.map((blogPost) =>
        blogPost.id === payload?.blogpost?.idBlog
          ? {...blogPost, saveBlogsForUser: response.data ? true : false}
          : blogPost
      );

      yield put(
        blogPostAction.setBlogPosts(
          blogsPostsUpdated,
          count,
          countTaxonomys
        )
      );
    }
    yield put(homeActions.setLoading(false));
  } catch (error) {
    if (error && error.response && error.response.status === 401) {
      yield put(logout());
    } else if (payload.callback) {
      if (error.message === "Network Error") {
        return payload.callback(
          "Error internet connection, Please check your intenert connection and try again."
        );
      } else {
        const { msg } = error?.response?.data || {};
        payload.callback(msg || "Something went wrong, please try again.");
      }
    }
  } finally {
    yield put(homeActions.setLoading(false));
  }
}

export function* searchBlogPostsSaga({ payload }) {
  yield put(homeActions.setLoading(true));

  try {
    const response = yield call(searchBlogPost, { ...payload });

    if (response.status === 200) {
      yield put(
        blogPostAction.setBlogPosts(
          response.data.blogsPosts,
          response.data.count,
          response.data.countTaxonomys
        )
      );
      yield put(homeActions.setLoading(false));
    }
  } catch (error) {
    console.log(error);

    if (error && error.response && error.response.status === 401) {
      yield put(logout());
    } else if (payload.callback) {
      const { msg } = error?.response?.data || {};
      payload.callback(msg || "Something went wrong, please try again.");
    }
  } finally {
    yield put(homeActions.setLoading(false));
  }
}

export function* searchBlogPostsForLinkBuilderSaga({ payload }) {
  // yield put(homeActions.setLoading(true));

  try {
    const response = yield call(searchBlogPostForLinkBuilder, payload.text);

    if (response.status === 200) {
      if(payload.callback){
        payload.callback(response.data.blogsPosts)
      }
      // yield put(homeActions.setLoading(false));
    }
  } catch (error) {
    console.log(error);

    if (error && error.response && error.response.status === 401) {
      yield put(logout());
    } else if (payload.callback) {
      const { msg } = error?.response?.data || {};
      payload.callback(msg || "Something went wrong, please try again.");
    }
  } finally {
    yield put(homeActions.setLoading(false));
  }
}

export function* getBlogPostByChannelIdSaga({ payload }) {
  yield put(homeActions.setLoading(true));

  try {
    const response = yield call(getBlogPostByChannelId, { ...payload });

    if (response.status === 200) {
      yield put(
        blogPostAction.setBlogsPostsByChannel(response.data.blogsPostByChannel)
      );
      yield put(homeActions.setLoading(false));
    }
  } catch (error) {
    console.log(error);

    if (error && error.response && error.response.status === 401) {
      yield put(logout());
    } else if (payload.callback) {
      const { msg } = error?.response?.data || {};
      payload.callback(msg || "Something went wrong, please try again.");
    }
  } finally {
    yield put(homeActions.setLoading(false));
  }
}

export function* getBlogPostByUserSaga({ payload }) {
  yield put(homeActions.setLoading(true));

  try {
    const response = yield call(getBlogPostByUser);

    if (response.status === 200) {
      yield put(
        blogPostAction.setBlogsPostsByUser(response.data.blogsPostByUser)
      );
      yield put(homeActions.setLoading(false));
    }
  } catch (error) {
    console.log(error);

    if (error && error.response && error.response.status === 401) {
      yield put(logout());
    } else if (payload.callback) {
      const { msg } = error?.response?.data || {};
      payload.callback(msg || "Something went wrong, please try again.");
    }
  } finally {
    yield put(homeActions.setLoading(false));
  }
}

export function* updateBlogPostSaga({ payload }) {
  yield put(homeActions.setLoading(true));

  try {
    const response = yield call(updateBlogPost, { ...payload });

    if (response.status === 200) {
      const selectAllState = (state) => state;

      const allState = yield select(selectAllState);

      const blogsPostByChannel = allState.blogPost.get("blogsPostByChannel");

      const blogsPostByChannelUpdated = blogsPostByChannel.map((blogPost) =>
        blogPost.id === response.data.affectedRows.id
          ? response.data.affectedRows
          : blogPost
      );

      if (payload.callback) {
        payload.callback();
      }

      yield put(
        blogPostAction.setBlogsPostsByChannel(blogsPostByChannelUpdated)
      );
      yield put(homeActions.setLoading(false));
    }
  } catch (error) {
    console.log(error);

    if (error && error.response && error.response.status === 401) {
      yield put(logout());
    } else if (payload.callback) {
      const { msg } = error.response.data || {};
      payload.callback(msg || "Something went wrong, please try again.");
    }
  } finally {
    yield put(homeActions.setLoading(false));
  }
}

export function* deleteBlogPostSaga({ payload }) {
  yield put(homeActions.setLoading(true));

  try {
    const response = yield call(deleteBlogPost, { ...payload });

    if (response.status === 200) {
      if (payload.callback) {
        payload.callback();
      }
      yield put(homeActions.setLoading(false));
    }
  } catch (error) {
  } finally {
    yield put(homeActions.setLoading(false));
  }
}

export function* setBlogPostLikeSaga({ payload }) {
  try {
    const response = yield call(addBlogPostLike, payload.data);

    if (response.status === 200) {
      if (payload.callback) {
        payload.callback(response.data.blogPostLike);
      }
    }
  } catch (error) {
    console.log(error);

    if (error && error.response && error.response.status === 401) {
      yield put(logout());
    }
  }
}

export function* deleteBlogPostLikeSaga({ payload }) {
  try {
    const response = yield call(removeBlogPostLike, payload.id);

    if (response.status === 200) {
      if (payload.callback) {
        payload.callback();
      }
    }
  } catch (error) {
    console.log(error);

    if (error && error.response && error.response.status === 401) {
      yield put(logout());
    }
  }
}

export function* getImagesCargSagas({ payload }) {
  
  try {
    if(Object.keys(payload.data)?.length !== 0){
      yield put(homeActions.setLoading(true));
      const response = yield call(getImagesCargEndPoint, payload.data);

      if (response.status === 200) {
        yield put(homeActions.setLoading(false));
        if (payload.callback) {
          payload.callback(response.data.images);
        }
      }
    }else{
      payload.callback(payload.data)
    }
  } catch (error) {
    console.log(error);
    yield put(homeActions.setLoading(false));

    if (error && error.response && error.response.status === 401) {
      yield put(logout());
    }
  }
}

function* watchChannel() {
  yield takeLatest(blogPostConstants.SEARCH_FOR_LINK_BUILDER, searchBlogPostsForLinkBuilderSaga)
  yield takeLatest(blogPostConstants.CREATE_BLOG_POST, createBlogPostSaga);
  yield takeLatest(blogPostConstants.SAVE_BLOG_POST, saveBlogPostSaga);
  yield takeLatest(blogPostConstants.SEARCH_BLOG_POSTS, searchBlogPostsSaga);
  yield takeLatest(
    blogPostConstants.GET_BLOGS_POSTS_BY_CHANNEL,
    getBlogPostByChannelIdSaga
  );

  yield takeLatest(blogPostConstants.UPDATE_BLOG_POST, updateBlogPostSaga);

  yield takeLatest(blogPostConstants.DELETE_BLOG_POST, deleteBlogPostSaga);

  yield takeLatest(blogPostConstants.SET_BLOG_POST_LIKE, setBlogPostLikeSaga);
  yield takeLatest(
    blogPostConstants.DELETE_BLOG_POST_LIKE,
    deleteBlogPostLikeSaga
  );
  yield takeLatest(blogPostConstants.GET_BLOG_POST_BY_USER, getBlogPostByUserSaga)
  yield takeLatest(blogPostConstants.GET_IMAGES_CARG, getImagesCargSagas)
}

export const blogPostSaga = [fork(watchChannel)];
